import classNames from 'classnames';
import type { RefObject } from 'react';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Identifier used by QE */
  'data-qe-id'?: string | null;
  /** Applies .container-fluid class if true */
  fluid?: boolean;
  /** Removes default left and right padding */
  flush?: boolean;
  /** Element reference */
  innerRef?: RefObject<HTMLDivElement> | ((instance: HTMLDivElement | null) => void) | null;
}

const defaultProps = {
  fluid: false,
  flush: false,
  innerRef: undefined,
  'data-qe-id': null,
};

export const Container: React.FC<ContainerProps> = (props) => {
  const { className, fluid, flush, innerRef, 'data-qe-id': qeId, ...attributes } = props;

  const classes = classNames(className, fluid ? 'container-fluid' : 'container', { 'container-flush': flush });

  return <div {...attributes} className={classes} data-qe-id={qeId} ref={innerRef} />;
};

Container.defaultProps = defaultProps;
Container.displayName = 'Container';

export default Container;
